import cn from 'classnames';
import A_ChatAvatar from '@/components/A_Atoms/A_ChatAvatar/A_ChatAvatar';
import { Conversation } from '@/services/chatApi';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';
import {
  conversationAvatar,
  conversationTitle,
  formatConversationTimestamp,
  messagePreviewText,
} from '@/utils/chat';
import styles from './M_ChatConversationItem.module.css';

interface M_ChatConversationItemProps {
  conversation: Conversation;
  currentUserId?: string;
  isActive?: boolean;
  onClick: (conversation: Conversation) => void;
}

export default function M_ChatConversationItem({
  conversation,
  currentUserId,
  isActive = false,
  onClick,
}: M_ChatConversationItemProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  const title = conversationTitle(conversation, t('chat.list.untitled'));
  const preview = messagePreviewText(
    conversation.lastMessage,
    t,
    currentUserId
  );
  const timestamp = formatConversationTimestamp(
    conversation.lastMessageAt,
    language
  );

  return (
    <button
      type='button'
      className={cn(styles.wrapper, { [styles.active]: isActive })}
      onClick={() => onClick(conversation)}
      aria-current={isActive}
    >
      <A_ChatAvatar
        title={title}
        src={conversationAvatar(conversation)}
        isGroup={conversation.kind === 'group'}
      />
      <div className={styles.body}>
        <div className={styles.row}>
          <span className={cn(styles.title, 'text-p-6')}>{title}</span>
          {timestamp && (
            <span className={cn(styles.timestamp, 'text-caption')}>
              {timestamp}
            </span>
          )}
        </div>
        <div className={styles.row}>
          <span className={cn(styles.preview, 'text-caption')}>{preview}</span>
          {conversation.unreadCount > 0 && (
            <span className={cn(styles.badge, 'text-caption')}>
              {conversation.unreadCount > 99 ? '99+' : conversation.unreadCount}
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
